import React from 'react'
import PageCreator from '../components/pages/Creator/Creator'
import Layout from '../Layouts/zh-hk'

const creatorZhHK = ({ location }) => {
  return (
    <Layout location={location}>
      <PageCreator />
    </Layout>
  )
}

export default creatorZhHK
